import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BazisInputDateComponent } from '@bazis/form/components/datetime/input-date.component';
import moment from 'moment';

@Component({
    selector: 'bazis-button-date',
    templateUrl: './button-date.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisButtonDateComponent extends BazisInputDateComponent implements OnInit {
    @Input()
    sideIcon: 'left' | 'right';

    buttonValue: string;

    openCalendar(ev) {
        super.openCalendar(ev);
        ev.preventDefault();
    }

    setValueFromCalendar(value: string[]) {
        super.setValueFromCalendar(value);
        this.buttonValue = value[0];
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.buttonValue = moment(this.ngControl.value).format(this.displayFormat).toString();
    }
}
